import React, { useEffect, useState } from "react";

import CardUpDown from "./cardupdown";
import CardAll from "./cardall";

import { DataLists } from "../dataLists/DataLists";

export type dataListsType = {
  id: number;
  title: string;
  urlinform: string;
  css: string;
  body: string;
  images: string[];
  tags: string[];
  description: string;
  category: string;
  nation: string;
};

const FeaturedPosts: React.FC = () => {
  const [featuredpostsFirstData, setFeaturedpostsFirstData] = useState<
    dataListsType[]
  >([]);

  const [featuredpostsSecondData, setFeaturedpostsSecondData] = useState<
    dataListsType[]
  >([]);

  const [featuredpostsOtherData, setFeaturedpostsOtherData] = useState<
    dataListsType[]
  >([]);

  const getFeaturedpostsFirstData = () => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    const data = randomData.slice(0, 1);
    setFeaturedpostsFirstData(data);
  };

  const getFeaturedpostsSecondData = () => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    const data = randomData.slice(0, 1);
    setFeaturedpostsSecondData(data);
  };

  const getFeaturedpostsOtherData = () => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    const data = randomData.slice(0, 3);
    setFeaturedpostsOtherData(data);
  };

  useEffect(() => {
    getFeaturedpostsFirstData();
    getFeaturedpostsSecondData();
    getFeaturedpostsOtherData();
  }, []);

  return (
    <div className="w-full flex justify-center mb-[60px]">
      <div className="w-full max-w-[1116px] px-8">
        <div className="h-[86px] flex items-center justify-between mt-3">
          <div className="flex items-center">
            <img src="icon/label2.png" alt="" className="w-5 h-5 mr-2" />
            <span className="text-base font-semibold">FEATURED POSTS</span>
          </div>
        </div>

        <div className="flex w-full mb-[30px] bg-white justify-between">
          <div className="w-[65.5%]">
            <CardAll props={featuredpostsFirstData} />
          </div>
          <div className="w-[32%]">
            <CardUpDown props={featuredpostsSecondData} />
          </div>
        </div>
        <div className="flex w-full justify-between bg-white gap-x-6">
          {featuredpostsOtherData.map((data, index) => (
            <div key={index} className="w-[33%]">
              <CardUpDown props={[data]} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedPosts;
